<template>
  <v-container v-if="schools&&schools.length > 0">
    <x-news
      :schoolId="school.id"
      class="mx-auto"
      v-for="(school,sindex) in schools"
      :key="sindex"
    ></x-news>
  </v-container>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../../firebaseConfig.js";
import moment from "moment";
import XNews from "./XNews.vue";
// import myfunction from 'global/myfunction.js';
// import VueResource from 'vue-resource';
// Vue.use(VueResource);
export default {
  name: "MyNews",
  data() {
    return {
      schools: [],
      userObject: null, // customer
    };
  },
  components: {
    XNews,
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  created() {
    this.readSchool();
  },

  methods: {
    async readSchool() {
      console.log(this.userProfile.customer.path);
      console.log(this.userProfile.schools);

      if (
        this.userProfile != null &&
        this.userProfile["role"] != null &&
        this.userProfile["role"] == "admin"
      ) {
        var querySnapshot = await fb.db.collection("schools").get();
        querySnapshot.forEach((schoolData) => {
          let school = schoolData.data();
          school.id = schoolData.id;
          school.ref = schoolData.ref;
          school.lessons = [];
          school.sharedlessons = [];
          this.schools.push(school);
        });
      } else if (
        this.userProfile != null &&
        this.userProfile["role"] != null &&
        (this.userProfile["role"] == "teacher" ||
          this.userProfile["role"] == "manager" ||
          this.userProfile["role"] == "sts")
      ) {
        if (this.userProfile.customer) {
          var cusDoc = await this.userProfile["customer"].get();
          let ddoc = cusDoc.data();
          if (cusDoc.exists) {
            if (cusDoc.data().school) {
              var schoolData = await cusDoc.data().school.get();
              let school = schoolData.data();
              school.id = schoolData.id;
              school.ref = schoolData.ref;
              school.lessons = [];
              school.sharedlessons = [];

              this.schools.push(school);
              this.userObject = cusDoc;
            } else if (ddoc.schools) {
              for (var ss of ddoc.schools) {
                console.log(ss)
                ss.get().then( (schoolDoc) =>{
                  let school = schoolDoc.data();
                  school.id = schoolDoc.id;
                  school.ref = schoolDoc.ref;
                  school.lessons = [];
                  school.sharedlessons = [];
                  this.schools.push(school);
                }) 
              }
            }
          }
        }
      }
    },
  },
};
</script>